import { useNavigate } from "react-router-dom";
import HeaderComponent from "../../components/header";
import ContainerComponent from "../../components/conatiner";
import CardHeaderBackgroundComponent from "../../components/cardHeaderBackground";
import InputComponent from "../../components/input";
import { ChangeEvent, useEffect, useState } from "react";
import TableComponent from "../../components/table";
import { CostCenterDeleteService, CostCentersService } from "../../services/center_cost";
import { ToastErro, ToastSucesso } from "../../components/toast";
import ModalComponent from "../../components/modal";

const CostCenterPage = () => {

    const navigate = useNavigate();

    const [loading, setLoading] = useState<boolean>(true);

    const [costCenters, setCostCenters] = useState<any>([]);

    // variaveis de pesquisa
    const [description, setDescription] = useState<string>('');
    const [page, setPage] = useState<number>(1);
    // variaveis de pesquisa

    // função para pesquisar centros de custo
    const getCostCenters = async () => {

        setLoading(true);

        await CostCentersService(description, page).then(resp => {
            setCostCenters(resp.data);
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
        });

        setLoading(false);

    }
    // função para pesquisar centros de custo

    // função para desativar ativar centro de custo
    const deleteCostCenter = async (id: number) => {

        (window as any).$("#modalDelete" + id).modal("hide");

        setLoading(true);

        await CostCenterDeleteService(id).then(resp => {
            ToastSucesso(resp.data.message);
            getCostCenters();
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
            setLoading(false);
        })

    }
    // função para desativar ativar centro de custo

    useEffect(() => {
        getCostCenters();
    }, [page]);

    return (
        <>
            <HeaderComponent
                title="Centros de Custo"
                button="Centro de Custo"
                iconButton="add"
                onClick={() => navigate('/cost_centers/create')}
            />
            <ContainerComponent>
                <>
                    <CardHeaderBackgroundComponent
                        title="Pesquisar"
                    >
                        <div className="row">
                            <InputComponent
                                label="Descrição"
                                col={8}
                                size={"small"}
                                onChange={(e: ChangeEvent<HTMLInputElement>) => setDescription(e.target.value)}
                                defaultValue={description}
                            />
                            <div className="col-md-4">
                                <button className="btn btn-primary" type="button" onClick={() => page > 1 ? setPage(1) : getCostCenters()}>Pesquisar</button>
                                <button className="btn btn-danger" type="button" style={{ marginLeft: 15 }} onClick={() => (window as any).location.reload()}>Limpar</button>
                            </div>
                        </div>
                    </CardHeaderBackgroundComponent>

                    <TableComponent
                        title="Centros de Custo"
                        columns={['ID', 'Descrição', 'Código', 'Filial', 'Qtd. Níveis', 'Ativo', 'Ações']}
                        loading={loading}
                        page={page}
                        last_page={costCenters?.last_page}
                        onClickPagination={(e: ChangeEvent<unknown>, value: number) => setPage(value)}
                    >
                        {
                            costCenters?.data?.map((c: any) => {
                                return (
                                    <tr key={c.id}>
                                        <td className="px-4">{c.id}</td>
                                        <td className="px-4">{c.description}</td>
                                        <td className="px-4">{c.code}</td>
                                        <td className="px-4">{c.branch}</td>
                                        <td className="px-4">{c.approval_levels}</td>
                                        <td className="px-4">
                                            {
                                                c.active == 1

                                                    ?

                                                    <h5><span className="badge bg-success">Sim</span></h5>

                                                    :

                                                    <h5><span className="badge bg-danger">Não</span></h5>
                                            }
                                        </td>
                                        <td className="px-4">
                                            <button className="btn btn-text-info" type="button" title="Informações" onClick={() => navigate(`/cost_centers/${c.id}`)}><i className="material-icons">info</i></button>                                            
                                            <button className="btn btn-text-danger" type="button" title={c.active === 1 ? 'Desativar' : 'Ativar'} onClick={() => (window as any).$("#modalDelete" + c.id).modal("show")}><i className="material-icons">{c.active == 1 ? 'delete' : 'upload'}</i></button>
                                            <ModalComponent
                                                title={c.active == 1 ? 'Desativar Centro de Custo' : 'Ativar Centro de Custo'}
                                                id={`modalDelete${c.id}`}
                                            >
                                                <>
                                                    <p>Você tem certeza que deseja {c.active == 1 ? 'desativar' : 'ativar'} o centro de custo abaixo?</p>
                                                    <div className="row mt-4">
                                                        <div className="col-md-12">
                                                            <table className="table">
                                                                <tbody>
                                                                    <tr>
                                                                        <td>ID:</td>
                                                                        <td>{c.id}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Descrição:</td>
                                                                        <td>{c.description}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Filial:</td>
                                                                        <td>{c.branch}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Código:</td>
                                                                        <td>{c.code}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                    <div className="d-flex justify-content-end mt-4">
                                                        <button className="btn btn-primary" type="button" onClick={() => deleteCostCenter(c.id)}>{c.active == 1 ? 'Desativar' : 'Ativar'}</button>
                                                    </div>
                                                </>
                                            </ModalComponent>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </TableComponent>
                </>
            </ContainerComponent>
        </>
    )

}

export default CostCenterPage;